import { Component, output } from '@angular/core';
import { Section } from '../legal-text.component';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  standalone: true,
})
export class PrivacyPolicyComponent {
  displaySectionEmitter = output<Section>();
}
